import React from 'react';
import clsx from 'clsx'

import {DecorativeAppIconProps} from "../AppIcon/AppIconProps";
import AppIcon from "../AppIcon/AppIcon";
import AppButton from '../AppButton/AppButton'
import { UI_BUTTON_TYPE } from '../AppButton/AppButtonProps'
import {ReactComponent as BackIcon} from '../../../icons/svg/arrow-back-icon.svg';
import {BackButtonProps} from './BackButtonProps'


import './BackButtonStyles.scss'

/**
 * ATOM – Komponent przycisku powrotu
 *
 */
const BackButton = (props: BackButtonProps) => {
    const {mobile, children,  className} = props

    const backIcon: DecorativeAppIconProps = {
        decorative: true,
        icon: BackIcon,
        width: '13px',
        height: '13px'
    }

    return (
        <>
            {mobile ?
                <button onClick={props.onClick} className={clsx(className,'app-back-button')}>
                    <AppIcon {...backIcon} />
                    {children ? children : 'Powrót'}</button>
                : 
                <AppButton uiButtonType={UI_BUTTON_TYPE.PRIMARY_OUTLINE} onClick={props.onClick} className='app-back-button-desktop'>
                    {children ? children : 'Powrót'}
                </AppButton>
            }
        </>
    )
}

export default BackButton